import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';
import { objectNotNullV2 } from '@/Utils/FnUtils';
import { GET_MONITOR_INDICATORS } from '../constants';
import type {
  GetMonitorIndicatorsParams,
  GetMonitorIndicatorsResponse,
} from '../types';

const getMonitorIndicators = (params: GetMonitorIndicatorsParams) =>
  apiClient
    .get<GetMonitorIndicatorsResponse>('/entregas/monitor/indicators', {
      params: objectNotNullV2(params),
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());

type GetMonitorIndicatorsData = Awaited<
  ReturnType<typeof getMonitorIndicators>
>;

export const useMonitorIndicators = (
  { cityId }: GetMonitorIndicatorsParams,
  options: Omit<
    UseQueryOptions<
      GetMonitorIndicatorsData,
      unknown,
      GetMonitorIndicatorsData,
      (string | undefined)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) =>
  useQuery({
    queryKey: [GET_MONITOR_INDICATORS, cityId],
    queryFn: () => getMonitorIndicators({ cityId }),
    keepPreviousData: true,
    ...options,
  });
